module.exports = __webpack_public_path__ + "img/pokemonitor.0dfc74e7.png";